import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CasesComponent } from './cases.component';
import { PayeeCasesModule } from 'src/app/shared/payee-cases/payee-cases.module';
import { HeaderModule } from '../header/header.module';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    CasesComponent
  ],
  imports: [
    CommonModule,
    PayeeCasesModule,
    HeaderModule,
    TranslateModule,
  ],
  exports: [
    CasesComponent,
  ],
})
export class CasesModule { }
